
export default {
  name: 'ConfiguratorHeadlightBlock',
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    showProductList: {
      type: Boolean,
      default: false,
    },
    reviews_count: {
      type: Number,
      default: 0,
    },
    products: {
      type: Array,
      default: () => [],
    },
    identifier: {
      type: String,
      required: true,
    },
    colorClass: {
      type: String,
      default: 'tw-from-gray-600 tw-to-gray-700',
    },
  },
  data() {
    return {
      alreadyOpened: false,
    }
  },
  methods: {
    toggleProductList() {
      this.alreadyOpened = true
      this.$emit('toggled', this.identifier)
    },
  },
}
